import { useEffect, useState } from "react";
import { userData } from "../js/utils";
import { post } from "../js/post";

export function useCRMLists(channel) {
  const [list, setList] = useState([]);

  async function getData() {
    const response = await post("support-extra/crm/ObtenerListasCRM.php", {
      token: userData.token,
      canal: channel,
    });
    setList(response);
    return response;
  }

  useEffect(() => {
    getData();
  }, [channel]);

  return { list, refresh: getData };
}
